const typeFormsRouter = [
    {
        path:'',
        name:'typeForms-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/typeForms/index.vue'),
        children:[
            {
                path:'',
                name:'typeForms-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視型質測量表單 或 點選新增型質測量表單' }
            },{
                path:'create',
                name:'typeForms-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/typeForms/create.vue')
            },{
                path:'detail/:id',
                name:'typeForms-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/typeForms/detail.vue')
            },{
                path:'edit/:id',
                name:'typeForms-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/typeForms/edit.vue')
            },
        ]
    },
    
  ]
  export default typeFormsRouter